module.exports = __webpack_public_path__ + "img/pr-4.9ed4d030.png";